// GST Toggle Functionality
// Default state: toggle checked = inc GST displayed (base price as-is)
// Unchecked state: GST removed from the displayed price
// GST calculation: gstAmount = price * 3 / 23 (NZ 15% GST)
// Each visible price element stores its inc-GST baseline in data-base-price
// so on-sale products update both the sale price and the compare-at price.
(function() {
  'use strict';

  var isUpdating = false;

  function calculateGstAmount(price) {
    return (price * 3) / 23;
  }

  function extractPrice(text) {
    var cleaned = text.replace(/[^\d.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  function formatPrice(amount) {
    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(Math.round(amount * 100));
    }
    return '$' + amount.toFixed(2);
  }

  function getVisiblePriceElements(priceContainer) {
    var fPrice = priceContainer.querySelector('.f-price');
    if (!fPrice) return [];

    var isOnSale = fPrice.classList.contains('f-price--on-sale');
    var elements = [];

    if (isOnSale) {
      var saleEl = fPrice.querySelector('.f-price__sale .f-price-item--sale');
      if (saleEl) elements.push(saleEl);
      var compareEl = fPrice.querySelector('.f-price__sale .f-price-item--regular');
      if (compareEl) elements.push(compareEl);
    } else {
      var regEl = fPrice.querySelector('.f-price__regular .f-price-item--regular');
      if (regEl) elements.push(regEl);
    }

    return elements;
  }

  // The compare-at price is wrapped in an <s> tag; update its text without
  // destroying the strikethrough element.
  function setPriceText(el, text) {
    var strikethrough = el.querySelector('s');
    if (strikethrough) {
      strikethrough.textContent = text;
    } else {
      el.textContent = text;
    }
  }

  // Always overwrite the stored baseline so the observer can refresh it after
  // Shopify renders a new variant price. Guarded by isUpdating so our own
  // writes don't get captured as the new base.
  function captureBasePrices(sectionId) {
    var priceContainer = document.getElementById('price-' + sectionId);
    if (!priceContainer) return [];

    var elements = getVisiblePriceElements(priceContainer);
    for (var i = 0; i < elements.length; i++) {
      var price = extractPrice(elements[i].textContent);
      if (price > 0) {
        elements[i].setAttribute('data-base-price', String(price));
      }
    }
    return elements;
  }

  function updatePrice(toggle, sectionId) {
    var priceContainer = document.getElementById('price-' + sectionId);
    if (!priceContainer || !toggle) return;

    var elements = getVisiblePriceElements(priceContainer);
    if (!elements.length) return;

    // Toggle checked = show inc GST (base price). Toggle unchecked = remove GST.
    var isIncGST = toggle.checked;

    isUpdating = true;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var baseAttr = el.getAttribute('data-base-price');
      var basePrice = baseAttr ? parseFloat(baseAttr) : extractPrice(el.textContent);
      if (!basePrice || basePrice === 0) continue;
      if (!baseAttr) {
        el.setAttribute('data-base-price', String(basePrice));
      }
      var gstAmount = calculateGstAmount(basePrice);
      var displayPrice = isIncGST ? basePrice : basePrice - gstAmount;
      setPriceText(el, formatPrice(displayPrice));
    }

    // Both labels reflect the current state.
    var label = toggle.closest('.toggle-switch');
    if (label) {
      var textEl = label.querySelector('.toggle-switch-text');
      if (textEl) {
        textEl.textContent = isIncGST ? 'inc GST' : 'excl GST';
      }
    }

    var gstLabel = priceContainer.querySelector('.product__gst-label');
    if (gstLabel) {
      gstLabel.textContent = isIncGST ? 'inc GST' : 'excl GST';
    }

    setTimeout(function() { isUpdating = false; }, 100);
  }

  function init() {
    var containers = document.querySelectorAll('.product__gst-toggle');
    if (!containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var toggle = container.querySelector('input[type="checkbox"]');
      if (!toggle || toggle.getAttribute('data-gst-init') === '1') continue;
      toggle.setAttribute('data-gst-init', '1');

      var sectionId = container.getAttribute('data-section-id');
      if (!sectionId) continue;

      // Capture the initial prices (inc GST) from every visible price element.
      var elements = captureBasePrices(sectionId);
      if (!elements.length) continue;

      // Toggle starts checked = inc GST is the default display, no price change needed.
      var priceContainer = document.getElementById('price-' + sectionId);
      if (priceContainer) {
        var gstLabel = priceContainer.querySelector('.product__gst-label');
        if (gstLabel) {
          gstLabel.textContent = toggle.checked ? 'inc GST' : 'excl GST';
        }
      }

      (function(sid, el) {
        el.addEventListener('change', function() {
          updatePrice(el, sid);
        });
      })(sectionId, toggle);

      // If the toggle was unchecked at init (e.g. browser-restored state),
      // re-apply the excl GST display now that we have the baselines.
      if (!toggle.checked) {
        updatePrice(toggle, sectionId);
      }
    }
  }

  // Wait for DOM and Shopify to finish rendering prices
  function start() {
    setTimeout(init, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-capture base price when Shopify updates the price (variant change)
  var bodyObserver = new MutationObserver(function(mutations) {
    if (isUpdating) return;

    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (!target || !target.id) continue;

      // Only react to changes inside price-* containers
      if (typeof target.id === 'string' && target.id.indexOf('price-') === 0) {
        var sid = target.id.replace('price-', '');
        // Shopify just updated the prices (inc GST). Re-capture all visible
        // baselines, then re-apply the excl GST view if the toggle is off.
        setTimeout(function(sectionId) {
          captureBasePrices(sectionId);
          var toggleContainer = document.querySelector('.product__gst-toggle[data-section-id="' + sectionId + '"]');
          if (toggleContainer) {
            var toggle = toggleContainer.querySelector('input[type="checkbox"]');
            if (toggle && !toggle.checked) {
              updatePrice(toggle, sectionId);
            }
          }
        }.bind(null, sid), 50);
        break;
      }
    }

    // Check for new toggle containers that need initialization
    var containers = document.querySelectorAll('.product__gst-toggle');
    for (var j = 0; j < containers.length; j++) {
      var toggle = containers[j].querySelector('input[type="checkbox"]');
      if (toggle && toggle.getAttribute('data-gst-init') !== '1') {
        init();
        break;
      }
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
